import IconButton from 'common/components/IconButton';
import React, { useEffect } from 'react';
import { ReactComponent as BackIcon } from 'common/icons/return.svg';
import ClientResponseProps from 'common/types/UserResponseProps';
import { ContentContainer } from 'pages/CreateOrderPage/styles/CreateOrderStyles';
import Button from 'common/components/Button';
import { FullItem, Separator } from '../OrderProductSettings';
import styled from '@emotion/styled';
import { ReactComponent as DotsVertical } from 'common/icons/dots-vertical.svg';
// plus, minus
import { ReactComponent as PlusIcon } from 'common/icons/plus.svg';
import { ReactComponent as MinusIcon } from 'common/icons/minus.svg';
import CartButton from 'pages/CreateOrderPage/components/CartButton';
import sendFetch from 'common/utils/fetch';

type CartPageProps = {
  setPageType: React.Dispatch<React.SetStateAction<string>>;
  client: ClientResponseProps | undefined;
  setStage: React.Dispatch<React.SetStateAction<number>>;
  itemList: FullItem[];
  setItemList: React.Dispatch<React.SetStateAction<FullItem[]>>;
  editItem: (item: FullItem) => void;
  deleteItem?: (id: number) => void;
  setMaxStage: React.Dispatch<React.SetStateAction<number>>;
  changeCount: (id: string | number, type: 'increase' | 'decrease') => void;
};

export const CartItemContainer = styled.div`
    display:flex;
    width: 100%;
    position: relative;
    padding-top: 16px;
    &:not(:last-child) {
        padding-bottom: 16px;
        border-bottom: 1px solid ${(props) => props.theme.colors.gray};
    }
`;

const CartItemMenu = styled.div`
    border-radius: 8px;
    width: 195px;
    height: 86px;
    display:flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    position: absolute;
    top: 48px;
    right: 0;
    border: 1px solid ${(props) => props.theme.colors.gray};
    background-color: ${(props) => props.theme.colors.backgroundColor};
    filter: drop-shadow(0px 6px 8px rgba(4, 13, 45, 0.25));
    z-index: 2;
`;

const TinyInput = styled.input`
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    width: 56px;
    height: 40px;
    color: ${(props) => props.theme.colors.primaryTextColor};
    flex-shrink: 0;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
    letter-spacing: 1px;
    text-align: center;
`;

export const CartItem = ({ changeCount, item, editItem, deleteItem, itemList, setItemList }: { item: FullItem, itemList: FullItem[], setItemList: React.Dispatch<React.SetStateAction<FullItem[]>>, editItem: (item: FullItem) => void, deleteItem?: (id: number | string) => void, changeCount: (id: string | number, type: 'increase' | 'decrease') => void }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [inputValue, setInputValue] = React.useState(item.count || '' as string);
  const [previousValue, setPreviousValue] = React.useState(item.count || '1' as string);

  const handleMenuOpen = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  useEffect(() => {
    // close if click outside
    const handleClickOutside = (e: MouseEvent) => {
      if (e.target instanceof HTMLElement && !e.target.closest('.order-cart-button-wrapper')) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const tinyInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // check if value is number or ''
    // no minuses or decimals
    if (value === '' || !isNaN(+value) && +value > 0 && value.indexOf('.') === -1) {
      setInputValue(value);
    } else {
      setInputValue(previousValue);
    }

  };
  const tinyInputFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setPreviousValue(value);
  };
  const tinyInputBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    let value = e.target.value;
    if (value === previousValue) return;
    if (value === '' || +value <= 0) value = '1';
    const formData = new FormData();
    formData.append('count', value);
    formData.append('id', item.id.toString());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const response:any = await sendFetch('https://api-workspace.astin.net/api/order/items/up-count-item', {  
      method: 'PATCH',
      data: formData,
    });
    if (response[0] === 200 && response[1].statusCode === 200) {
      setInputValue(response[1].count.toString());
      // update itemList
      console.log(item);
      console.log(itemList);
      const itemIndex = itemList.findIndex((itemInner) => itemInner.id === item.id);
      if (itemIndex === -1) return;
      const newItemList = [...itemList];
      newItemList[itemIndex].count = response[1].count;
      if (response[1].isMax) {
        // disable plus
        newItemList[itemIndex].isMaxCount = true;
      }
      setItemList(newItemList);
      
    } else {
      setInputValue(previousValue);
    }
    setPreviousValue(null);
  };
  useEffect(() => {
    // find val in itemlist
    const itemIndex = itemList.findIndex((itemInner) => itemInner.id === item.id);
    if (itemIndex === -1) return;
    // update inputValue
    setInputValue(itemList[itemIndex].count.toString());
  }, [itemList]);
  const disabledStyles: React.CSSProperties = {
    opacity: 0.5,
    cursor: 'default',
  };
  return (
        <CartItemContainer>
            <div className='order-cart-item-text-wrapper'>
                { item.type === 'service' ? <><span className='order-cart-item-title'>{item.categoryName}</span>
                {item.name && <span className='order-cart-item-subtitle'>{item.name}</span>}</> : 
                <><span className='order-cart-item-title'>{item.name}</span></>}
            </div>

            {item.type === 'product' ? <div className='order-cart-item-input-wrapper'>
                <MinusIcon
                  style={item.count <= 1 ? disabledStyles : {}}
                  className='svg-black'
                  onClick={() => { if (item.count > 1) changeCount(item.id, 'decrease'); }} 
                />
                <TinyInput value={inputValue} maxLength={4} onChange={tinyInputChange} onBlur={tinyInputBlur} onFocus={tinyInputFocus}/>
                <PlusIcon
                  style={item.isMaxCount ? disabledStyles : {}}
                  className='svg-black'
                  onClick={() => { if (!item.isMaxCount) changeCount(item.id, 'increase'); }}
                />
            </div> : <div className='order-cart-item-input-wrapper'></div>}

            <span className='order-cart-item-price'>{item?.price?.toFixed(2) || '0.00'} ₴</span>

            <div className='order-cart-button-wrapper'>
                <div className='order-cart-button-icon' onClick={handleMenuOpen}>
                    <DotsVertical className='svg-black' />
                </div>
                {isMenuOpen && <CartItemMenu>
                    <span onClick={() => { editItem(item); }} className='new-p order-cart-button-text'>Змінити</span>
                    <Separator />
                    <span onClick={() => { deleteItem(item.id); }} className='new-p order-cart-button-text'>Видалити</span>
                </CartItemMenu>}
            </div>
        </CartItemContainer>
  );
};

export default function CartPage({ changeCount, setPageType, client, setStage, setMaxStage, itemList, setItemList, editItem, deleteItem }: CartPageProps) {
  console.log(itemList);

  const handleOrder = () => {
    setStage(3);
    setMaxStage(4);
    setPageType('order');
  };

  return (
        <div className='order-content-container'>
            <div className='order-top-line'>
                <div className='order-top-line-client-wrapper'>
                    <p>Клієнт:</p>
                    <p className='basic-link' onClick={() => { setStage(1); }}>{client && `${client.lastName} ${client.firstName[0]}.${client.patronymic ? client.patronymic[0] + '.' : ''}`}</p>
                </div>
                <div className='order-top-line-button-wrapper'>
                    <IconButton onClick={() => { setPageType('order'); }}>
                        <BackIcon className='svg-black svg-fill' />
                    </IconButton>
                    <CartButton active setPageType={setPageType} itemCount={itemList.length} type='order' />
                </div>
            </div>
            <ContentContainer>
                <div className='find-client-top-line'>
                    <span className='big-text'>
                        Кошик
                    </span>
                    <span className='order-subtext gray-text'>

                    </span>
                </div>
                <div className='order-cart-list-wrapper'>
                    <div className='order-cart-list u-fancy-scrollbar'>
                        {itemList.map((item, index) => <CartItem changeCount={changeCount} editItem={editItem} deleteItem={deleteItem} key={index} item={item} itemList={itemList} setItemList={setItemList} />)}
                    </div>
                </div>
                <div className='order-cart-price-wrapper'>
                    <Separator />
                    <div className='order-cart-price-line'>
                        <span className='order-cart-price-text'>Загальна сума</span>
                        <span className='order-cart-price'>{itemList.reduce((acc, item) => acc + item.price * item.count, 0).toFixed(2)} ₴</span>
                    </div>
                </div>
            </ContentContainer>
            <div className='order-product-button-wrapper'>
                <Button disabled label='У чернетку' />
                <Button onClick={handleOrder} disabled={itemList.length < 1} primary label='Оформити' />
            </div>
        </div>
  );
}